import { type FC } from 'react'
import { Layout } from '@egw/layouts'
import { Headers } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { RecoveryProblemPage } from '@egw/features-auth'

export const PasskeyRecoveryProblemPage: FC = () => {
  const { t } = useTranslation()
  return (
    <Layout>
      <Headers title={t('pages.recovery.title')} />
      <RecoveryProblemPage />
    </Layout>
  )
}
